module.exports = __webpack_public_path__ + "img/certificate.53a5600d.jpg";